// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.popup-text[data-v-73b7313a] {\n  margin-bottom: 15px;\n}\n.td-link[data-v-73b7313a] {\n  width: 18rem;\n}\n.td-link > *[data-v-73b7313a] {\n  margin-bottom: 0.5rem;\n  min-width: 6rem;\n}\n.td-link > *[data-v-73b7313a]:first-child {\n  margin-right: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
